import { LabelBadge } from './label-badge';
import type { ClassificationLabelMap } from '@/hooks/use-classification-label';
import { formatSlug } from '@/hooks/use-classification-label';

interface ClassificationBadgeProps {
  classification: string;
  labelMap: ClassificationLabelMap;
  size?: 'sm' | 'default';
  className?: string;
}

/**
 * Renders a colored badge for a classification slug by resolving it
 * against the org's classification_labels. Falls back to formatted slug
 * for unknown classifications.
 */
export function ClassificationBadge({
  classification,
  labelMap,
  size = 'sm',
  className,
}: ClassificationBadgeProps): React.ReactElement {
  const info = labelMap.get(classification);
  const displayName = info?.displayName ?? formatSlug(classification);
  const color = info?.color ?? null;

  return <LabelBadge label={{ displayName, color }} size={size} className={className} />;
}
